import { PipeTransform } from '@angular/core';
import { TitleCasePipe } from 'pipes/titlecase.pipe';
var CategoryCabinetPipe = /** @class */ (function () {
    function CategoryCabinetPipe(titleCasePipe) {
        this.titleCasePipe = titleCasePipe;
    }
    CategoryCabinetPipe.prototype.transform = function (value, Categories) {
        var self = this;
        if (value == null) {
            return 'Not Assigned';
        }
        var entry = (Categories || []).find(function (c) { return c.CategoryID === value; });
        if (!entry || !entry.CabinetMember) {
            return '';
        }
        var fullname = self.titleCasePipe.transform(entry.CabinetMember.FirstName) + " " + self.titleCasePipe.transform(entry.CabinetMember.LastName);
        return fullname;
    };
    return CategoryCabinetPipe;
}());
export { CategoryCabinetPipe };
